const clients = {
  title: "Client Management",
  clientProfile: "Client profile",
  viewClient: "View Client",
  details: "Details",
  editProfile: "Edit Profile",
  editProfilePageTitle: "Edit profile",
  editBreadcrumb: "Edit",
  saveChanges: "Save Changes",
  profileUpdatedSuccess: "Client profile updated successfully.",
  searchPlaceholder: "Search by Name...",
  emptyTitle: "No clients yet",
  emptyDescription: "Add your first client to get started.",
  noDataDescription: "Sorry, No clients found.",
  profile: "Profile",
  email: "Email",
  mobileNumber: "Mobile Number",
  editClient: "Edit",
  editClientTitle: "Edit Client",
  showingRange: "Showing {from}-{to} of {total} clients",
  manageClient: "Manage Client",
  addClient: {
    createClient: "Add Client",
    addClient: "Add Client",
    addNewClientTitle: "Add new client",
    detailsTitle: "Details",
    name: "Name",
    email: "Email",
    mobileNumber: "Mobile number",
    labels: {
      name: "Name",
      email: "Email",
      mobileNumber: "Mobile number",
    },
    placeholders: {
      name: "Enter name",
      email: "Enter email",
      mobileNumber: "Enter mobile number",
    },
  },
  listClients: {
    clients: "Clients",
    listClientsBreadcrumb: "Clients Management",
    name: "Name",
    email: "Email",
    mobile: "Mobile Number",
    phone: "Phone Number",
    companyName: "Company Name",
  },
};

export default clients;
